import {createSlice, PayloadAction} from "@reduxjs/toolkit";

// Set the initial state
const locationDefinitionModeSliceInitialState: string = "manual";

// Create the slice
const locationDefinitionModeSlice = createSlice({
    name: "locationDefinitionMode",
    initialState: locationDefinitionModeSliceInitialState,
    reducers: {
        // Reducer to set the location definition mode
        setLocationDefinitionMode: (_, action: PayloadAction<string>) => {
            return action.payload; // Explicitly return the new state
        }
    }
});

// Export the actions and reducer
export const locationDefinitionModeSliceActions = locationDefinitionModeSlice.actions;
export default locationDefinitionModeSlice;